import { useEffect, useRef, useState } from "react";

interface UseDropdownProps {
  initialOpen?: boolean;
  closeAfterClick?: boolean;
}

export function useDropdown({
  initialOpen = false,
  closeAfterClick = false,
}: UseDropdownProps = {}) {
  const [isOpen, setIsOpen] = useState(initialOpen);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (event: MouseEvent) => {
      if (closeAfterClick) {
        setTimeout(() => setIsOpen(false), 100);
        return;
      }
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, closeAfterClick]);

  return { isOpen, setIsOpen, dropdownRef };
}
